import React from 'react';

const Spinner = ({ fill = '#000000' }) => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 6C12 7.42862 11.4902 8.81036 10.5624 9.89669C9.63462 10.983 8.34964 11.7026 6.93861 11.9261C5.52758 12.1496 4.08311 11.8623 2.86501 11.1158C1.64691 10.3694 0.735128 9.2128 0.293661 7.8541C-0.147807 6.49541 -0.089986 5.02377 0.456723 3.7039C1.00343 2.38403 2.00315 1.30254 3.27606 0.653961C4.54897 0.00538162 6.01153 -0.167724 7.40067 0.16578C8.78982 0.499285 10.0144 1.31751 10.8541 2.47329L9.88328 3.17863C9.2115 2.25401 8.23185 1.59943 7.12054 1.33262C6.00922 1.06582 4.83917 1.20431 3.82085 1.72317C2.80252 2.24203 2.00274 3.10722 1.56538 4.16312C1.12801 5.21902 1.08175 6.39632 1.43493 7.48328C1.7881 8.57024 2.51753 9.49551 3.49201 10.0927C4.46649 10.6898 5.62206 10.9197 6.75089 10.7409C7.87971 10.5621 8.9077 9.98641 9.64995 9.11735C10.3922 8.24829 10.8 7.1429 10.8 6H12Z"
        fill={fill}
      />
    </svg>
  );
};

export default Spinner;
